import { z } from 'zod';
import { idArray } from './shared.schema';

export const leaseAllocationReportFormatSchema = z.enum(['csv', 'xlsx']);

export const leaseAllocationParametersSchema = z.strictObject({
	areaIds: idArray.optional(),
	branchIds: idArray.optional(),
	districtIds: idArray.optional(),
	facilityIds: z.array(z.string()).optional(),
	facilityNumber: z.union([z.string(), z.number()]).optional(),
	asOfDate: z.iso.date(),
	format: leaseAllocationReportFormatSchema.default('csv'),
});

export type LeaseAllocationParameters = z.infer<typeof leaseAllocationParametersSchema>;
export type LeaseAllocationReportFormat = z.infer<typeof leaseAllocationReportFormatSchema>;
